const LOG_CACHE =
  process.env.NODE_ENV !== 'production' &&
  window.location.href.indexOf('debug=1') > -1

class Cache {
  registry = {}

  constructor(label) {
    this.label = label
  }

  get(key) {
    if (LOG_CACHE) {
      console.log(`${this.label}::get`, key, this.registry)
    }

    return this.registry[key] || null
  }

  set(key, value) {
    if (LOG_CACHE) {
      console.log(`${this.label}::set`, key, value, this.registry)
    }

    this.registry[key] = value
  }

  clear(key) {
    delete this.registry[key]
  }
}

export default Cache
